import { render } from "./LogoUploader.vue?vue&type=template&id=0c53b216&scoped=true"
import script from "./LogoUploader.vue?vue&type=script&lang=js"
export * from "./LogoUploader.vue?vue&type=script&lang=js"

import "./LogoUploader.vue?vue&type=style&index=0&id=0c53b216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c53b216"]])

export default __exports__